import { CommonModule } from '@angular/common';
import { Component, effect, inject, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LocaleService } from 'src/app/services/locale';
import { PaymentService } from 'src/app/services/payment';
import { PlanComponent } from './plan';

@Component({
  selector: 'app-plans',
  imports: [CommonModule, ReactiveFormsModule, PlanComponent],
  template: `
    <div *ngIf="planType" class="space-y-4">
      <!-- Section Header -->
      <div class="bg-white rounded-2xl shadow-lg p-4 border border-gray-100 mt-5">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-[#043B22]/10 rounded-xl flex items-center justify-center">
            <svg class="w-5 h-5 text-[#043B22]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
            </svg>
          </div>
          <div>
            <h2 class="text-lg sm:text-xl futura text-[#043B22]">{{ locale.common.stas }}</h2>
            <p class="text-xs sm:text-sm text-[#616161]">
              {{ locale.common.cttop }}
            </p>
          </div>
        </div>        
      </div>

      <!-- Monthly Plans -->
      <div>
        <div class="flex items-center gap-2 mb-4 sm:mb-6">
          <div class="w-1 h-6 bg-[#043B22] rounded-full"></div>
          <h3 class="text-base sm:text-lg lg:text-xl futura text-[#043B22]">
            {{ planType }} {{ locale.common.mp }}
          </h3>
        </div>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6"
        >
          <app-plan
            [profile]="profile"
            *ngFor="let plan of plans"
            [plan]="plan"
            [select]="selectPlan"
            [selected]="selectedPlan"
          ></app-plan>
        </div>
      </div>

      <!-- Annual Plans -->
      <div *ngIf="annualPlans && annualPlans.length > 0">
        <div class="flex items-center gap-2 mb-4 sm:mb-6">
          <div class="w-1 h-6 bg-[#043B22] rounded-full"></div>
          <h3 class="text-base sm:text-lg lg:text-xl futura text-[#043B22]">
            {{ planType }} {{ locale.common.ap }}
          </h3>
          <span class="ml-2 px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded-full">
            {{ language === 'english' ? 'Save up to 20%' : 'Risparmia fino al 20%' }}
          </span>
        </div>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6"
        >
          <app-plan
            [profile]="profile"
            *ngFor="let plan of annualPlans"
            [plan]="plan"
            [select]="selectPlan"
            [selected]="selectedPlan"
          ></app-plan>
        </div>
      </div>
    </div>
  `
})
export class PlansComponent {
  @Input() profile = false;
  @Input() selectPlan: any;
  @Input() selectedPlan: any;
  @Input() planType: any = null;

  private localeService = inject(LocaleService);
  payment = inject(PaymentService);

  locale = this.localeService.locale();
  language = this.localeService.getLanguage();

  plans: any = null;
  annualPlans: any = null;

  constructor() {
    effect(() => {
      this.locale = this.localeService.locale();
      this.language = this.localeService.getLanguage();
      // Re-fetch plans when language or payment plans change
      const _ = this.payment.plans();
      this.setPlans();
    });
  }

  setPlans = () => {
    this.plans =
      this.planType === 'Consultant'
        ? this.payment.plans().consultant
        : this.payment.plans().corporate;

    if (this.profile && this.selectedPlan) {
      this.plans = this.plans.filter((x: any) => x.id !== this.selectedPlan.id);
    }

    if (this.planType === 'Corporate') {
      this.annualPlans = this.plans.filter(
        (x: any) => x.duration === 'year' || x.duration === 'anno'
      );
      this.plans = this.plans.filter(
        (x: any) => x.duration === 'month' || x.duration === 'mese'
      );
    } else {
      this.annualPlans = null;
    }
  };

  ngOnInit(): void {
    this.setPlans();
  }

  ngOnChanges() {
    this.setPlans();
  }
}
